export default __webpack_public_path__ + "static/media/delivery.a1962521.svg";